import { ConfigService } from '@maia/config';
import { TaskController } from './task.controller';
import { HttpService } from '@maia/httpClient';
import { TaskService } from '@maia/shared';

export class ServiceFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(this.configService, 'apiUrl');

  createTaskController(): TaskController {
    return new TaskController(this.createTaskService());
  }

  private createTaskService(): TaskService {
    return new TaskService(this.httpService, this.configService);
  }
}

const factory = new ServiceFactory();
export const service = factory.createTaskController();
